(() => {
  const faqItemSelector = '.sp-faq-question-item';
  let generatedId = 0;

  const enhanceFaqItem = (item) => {
    const trigger = item.querySelector('.sp-faq-question-heading');
    const panel = item.querySelector('.sp-faq-question-content');

    if (!trigger || !panel || trigger.dataset.ffFaqReady === 'true') return;

    generatedId += 1;
    const itemId = item.id || `ff-faq-${generatedId}`;
    const triggerId = `${itemId}-trigger`;
    const panelId = `${itemId}-panel`;

    trigger.id = trigger.id || triggerId;
    panel.id = panel.id || panelId;
    trigger.dataset.ffFaqReady = 'true';
    const isNativeControl = trigger.matches(
      'button, a[href], summary, input, select, textarea'
    );

    if (!isNativeControl) {
      trigger.setAttribute('role', 'button');
      trigger.setAttribute('tabindex', '0');
    }

    trigger.setAttribute('aria-controls', panel.id);
    panel.setAttribute('role', 'region');
    panel.setAttribute('aria-labelledby', trigger.id);

    const syncState = () => {
      const isOpen = item.classList.contains('is-selected');
      trigger.setAttribute(
        'aria-expanded',
        isOpen ? 'true' : 'false'
      );
      panel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      panel.inert = !isOpen;
    };

    if (!isNativeControl) {
      trigger.addEventListener('keydown', (event) => {
        if (event.target !== trigger) return;
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        event.stopPropagation();

        const wasOpen = item.classList.contains('is-selected');
        const faqContent = item.closest('.sp-faq-content');

        faqContent?.querySelectorAll(faqItemSelector).forEach((faqItem) => {
          faqItem.classList.remove('is-selected');
        });

        if (!wasOpen) item.classList.add('is-selected');
      });
    }

    trigger.addEventListener('click', () => requestAnimationFrame(syncState));
    new MutationObserver(syncState).observe(item, {
      attributes: true,
      attributeFilter: ['class'],
    });

    syncState();
  };

  const enhanceFaq = (scope = document) => {
    scope.querySelectorAll(faqItemSelector).forEach(enhanceFaqItem);
  };

  const initialize = () => enhanceFaq();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => {
    enhanceFaq(event.target);
  });
})();
